<button class="vertical-aligner-component w-100 h-100 m-0">
  <ng-content></ng-content>
</button>
